import H4 from './H4';

export default H4;
export * as H4Styles from './H4.styles';
export * as H4Types from './H4.types';
